/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { ScriptMetadata } from "./ScriptMetadata";
import * as t from "io-ts";

/**
 * The complete list of scripts to be used for dynamic mock behavior.
 */

// required attributes
const ScriptMetadataListR = t.interface({
  scripts: t.readonlyArray(ScriptMetadata, "array of ScriptMetadata")
});

// optional attributes
const ScriptMetadataListO = t.partial({});

export const ScriptMetadataList = t.intersection(
  [ScriptMetadataListR, ScriptMetadataListO],
  "ScriptMetadataList"
);

export type ScriptMetadataList = t.TypeOf<typeof ScriptMetadataList>;
